import { createSlice } from "@reduxjs/toolkit";
import billingAuditList from "../../../rtk-apis/audit/billingAuditLogs";

const initialState = {
  status:"",
  result:{},
  msg:"",
  loading:false,
  error:"",
  pagination: null,
};

const billingAuditListSlice = createSlice({
  name: "billingAuditListSlice",
  initialState,
  reducers: {
    clearBillingAuditState: (state) => {
      state.status = '';
      state.result = '';
      state.msg = '';
      state.loading = false;
      state.error = '';
      state.pagination = null;
    }
  },
  extraReducers: (builder) => {
    builder
      .addCase(billingAuditList.pending, (state, action) => {
        console.log("Pending")
        state.loading = true;
      })
      .addCase(billingAuditList.fulfilled, (state, { payload }) => {
        console.log("Fulfilled",payload)
        state.loading = false;
        state.status = payload.status;
        state.result = payload.data;
        state.msg = payload.msg;
        state.pagination = payload.pagination;
      })
      .addCase(billingAuditList.rejected, (state, { payload }) => {
        console.log("Rejected")
        state.result = payload;
        state.loading = false;
      });
  },
});

export const { clearBillingAuditState } = billingAuditListSlice.actions;
export default billingAuditListSlice.reducer;
